var runtime = require("../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"social-share":"_3OdnI","socialShare":"_3OdnI"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3OdnI{display:inline-flex;align-items:stretch;justify-content:space-between;height:auto;direction:ltr}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

